import {
    GETMAPPINGBANKNAMELIST_SUCCESS,
    GETMAPPINGBANKNAMELIST_FAILED,
    RESET_GETMAPPINGBANKNAMELIST,
    LOADING_GETMAPPINGBANKNAMELIST,
    NETWORK_ERROR_GETMAPPINGBANKNAMELIST
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetGetMappingBankNameList = () => {
    return { type: RESET_GETMAPPINGBANKNAMELIST };
};

const partnerGetMappingBankName = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPINGBANKNAMELIST });
    await partnerServices
        .post("getMappingBankAllList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerGetMappingBankNamesuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetMappingBankNameFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMAPPINGBANKNAMELIST,
                payload: err
            });
        });
};

function partnerGetMappingBankNamesuccess(data) {
    return {
        type: GETMAPPINGBANKNAMELIST_SUCCESS,
        payload: data,
    };
}

function partnerGetMappingBankNameFailed(data) {
    return {
        type: GETMAPPINGBANKNAMELIST_FAILED,
        payload: data,
    };
}

export { resetGetMappingBankNameList, partnerGetMappingBankName }